// extracted by mini-css-extract-plugin
export var formContainer = "ContactFormBlock-module--formContainer--3JjsP";
export var form = "ContactFormBlock-module--form--gMtBc";
export var show = "ContactFormBlock-module--show--3kZt7";
export var showFadeInDown = "ContactFormBlock-module--show-fade-in-down--1FWCO";
export var showFadeInUp = "ContactFormBlock-module--show-fade-in-up--253H4";
export var hideFadeOut = "ContactFormBlock-module--hide-fade-out--2U4qQ";